module.exports = __webpack_public_path__ + "img/imagen_parrafo_tres.98c27801.jpg";